<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid height="calc(100vh - 320px)"
		[dataSource]="viewModel.dataSource"
		[remoteOperations]="true"
		[showBorders]="true"
		(onRowRemoving)="rowRemoving($event, viewModel)"
		(onEditorPreparing)="onEditorPreparing($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-pager [showPageSizeSelector]="true"></dxo-pager>
		<dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="canManageUsers" [allowDeleting]="canManageUsers"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="id"
			caption="ID"
			[visible]="false"
		>
		</dxi-column>
		<dxi-column
			dataField="createdOn"
			dataType="datetime"
			caption="Created on"
		>
		</dxi-column>
		<dxi-column
			dataField="userName"
			caption="Username"
		>
		</dxi-column>
		<dxi-column
			dataField="firstName"
			caption="First name"
		>
		</dxi-column>
		<dxi-column
			dataField="lastName"
			caption="Last name"
		>
		</dxi-column>
		<dxi-column
			dataField="email"
			caption="Email"
		>
		</dxi-column>
		<dxi-column *ngIf="canManageGroups" caption="Groups" [width]="160" [allowFiltering]="false" [allowSorting]="false" cellTemplate="groupsCellTemplate"></dxi-column>
		<dxi-column caption="Permissions" [width]="170" [allowFiltering]="false" [allowSorting]="false" cellTemplate="permissionsCellTemplate"></dxi-column>
		<dxi-column type="buttons" [width]="96" *ngIf="canManageUsers">
			<dxi-button name="edit"></dxi-button>
			<dxi-button name="delete"></dxi-button>
		</dxi-column>

		<div class="groups-cell" *dxTemplate="let cell of 'groupsCellTemplate'">
			<dx-button text="Manage groups" icon="far fa-users" stylingMode="outlined" (onClick)="manageGroupsFromCell(cell)"></dx-button>
		</div>

		<div class="groups-cell" *dxTemplate="let cell of 'permissionsCellTemplate'">
			<dx-button text="View permissions" icon="far fa-user-shield" stylingMode="outlined" (onClick)="viewPermissionsFromCell(cell)"></dx-button>
		</div>
	</dx-data-grid>

	<dx-popup
		[(visible)]="groupManagementVisible"
		[showCloseButton]="true"
		[showTitle]="true"
		[width]="640"
		[height]="'auto'"
		[dragEnabled]="true"
		[closeOnOutsideClick]="!groupManagementSaving"
		title="Manage group assignments"
		(onHiding)="closeGroupManagement()"
	>
		<div class="group-management-popup">
			<div class="group-management-popup__title" *ngIf="selectedUser">
				Assign groups for {{ selectedUser.firstName }} {{ selectedUser.lastName }}
			</div>

			<div *ngIf="groupManagementLoading" class="group-management-popup__message">
				Loading groups...
			</div>

			<ng-container *ngIf="!groupManagementLoading">
				<div class="group-management-popup__message" *ngIf="reservedAssignedGroups.length > 0">
					Reserved groups remain assigned and can only be changed by superadmins:
					<strong>{{ reservedAssignedGroupNames }}</strong>
				</div>

				<dx-tag-box
					[dataSource]="availableGroups"
					[(value)]="selectedGroupIds"
					valueExpr="id"
					displayExpr="name"
					[showSelectionControls]="true"
					[searchEnabled]="true"
					[hideSelectedItems]="false"
					[disabled]="groupManagementSaving"
					placeholder="Select one or more groups"
				>
				</dx-tag-box>

				<div class="group-management-popup__actions">
					<dx-button text="Cancel" type="normal" [disabled]="groupManagementSaving" (onClick)="closeGroupManagement()"></dx-button>
					<dx-button text="Save" type="success" [disabled]="groupManagementSaving" (onClick)="saveGroupAssignments()"></dx-button>
				</div>
			</ng-container>
		</div>
	</dx-popup>
</ng-container>
